import { FC, Fragment } from "react"
import { ModalConfirm } from "../../../../../../_webui/layout/components/Modal/Confirm"
import { Translate } from "../../../../../../constant/Translate"
import { SchedulesModalConfirmProps } from "./models"
import { replaceStringParam } from "../../../../../../utils/replaceStringParam"
import { Variables } from "../../../constants/list/variables"

const { MESSAGE_I0020, MESSAGE_C0043, MESSAGE_C0060, TEXT_T229 } = Translate
const { EXPORT_FRM103_OVER_RECORD, SCHEDULE_LIST_OVER_RECORD } = Variables

export const SchedulesModalConfirm: FC<SchedulesModalConfirmProps> = (
  props,
) => {
  const {
    isOpen,
    isOpenExportFrm103OverRecord,
    isOpenLoadData,
    isOpenShowData,
    messageConfirmDownload,
    onCancel,
    onCancelCustomLoadData,
    onCancelExportFrm103OverRecord,
    onOk,
    onOkExportFrm103OverRecord,
    onOkLoadData,
    onOkShowData,
  } = props

  return (
    <Fragment>
      <ModalConfirm isOpen={isOpen} onCancel={onCancel} onOk={onOk}>
        {messageConfirmDownload}
      </ModalConfirm>
      <ModalConfirm
        cancelCustomText={TEXT_T229}
        cancelText=""
        isOpen={isOpenLoadData}
        onCancelCustom={onCancelCustomLoadData}
        onOk={onOkLoadData}
      >
        {replaceStringParam(MESSAGE_C0043, SCHEDULE_LIST_OVER_RECORD)}
      </ModalConfirm>
      <ModalConfirm
        cancelText=""
        isCenter
        isOpen={isOpenShowData}
        onOk={onOkShowData}
      >
        {MESSAGE_I0020}
      </ModalConfirm>
      <ModalConfirm
        isOpen={isOpenExportFrm103OverRecord}
        onCancel={onCancelExportFrm103OverRecord}
        onOk={onOkExportFrm103OverRecord}
      >
        {replaceStringParam(MESSAGE_C0060, EXPORT_FRM103_OVER_RECORD)}
      </ModalConfirm>
    </Fragment>
  )
}
